/**
 * Theme utility functions for dynamic theme loading
 */

// Import the existing hexToHSL function from bgUtils
// Note: This converts a hex color to [h, s, l] array where values are 0-1
const hexToHSL = (hex: string): [number, number, number] => {
  const r = parseInt(hex.slice(1, 3), 16) / 255;
  const g = parseInt(hex.slice(3, 5), 16) / 255;
  const b = parseInt(hex.slice(5, 7), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let h, s;

  if (max === min) {
    h = s = 0; // achromatic
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
      default: h = 0;
    }
    h /= 6;
  }

  return [h, s, l];
};

/**
 * Convert hex color to CSS HSL string format "H S% L%"
 * @param hex - Hex color string (e.g., "#ff0000")
 * @returns CSS HSL string (e.g., "0 100% 50%")
 */
export const hexToCSSHSL = (hex: string): string => {
  const [h, s, l] = hexToHSL(hex);
  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
};